import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { faArrowLeft, faBox, faBoxOpen, faPen, faSeedling, faSitemap } from '@fortawesome/free-solid-svg-icons';
import { filter, pairwise } from 'rxjs/operators';
import { ErrorService } from '../../../../../../@core/utils/error.service';
import { InventoryService } from '../../../../pick-plan/services/inventory.service';
import { InventoryItemDTO } from '../../../models/item';
import { InventoryItemAttributeValueDTO } from '../../../models/item-attribute-value';
import { InventoryItemEditComponent } from '../inventory-item-edit/inventory-item-edit.component';

@Component({
  selector: 'inventory-item-detail',
  templateUrl: './inventory-item-detail.component.html',
  styleUrls: ['./inventory-item-detail.component.scss']
})
export class InventoryItemDetailComponent implements OnInit {

  private destroyRef = inject(DestroyRef);

  public faArrowLeft = faArrowLeft;
  public faBox = faBox;
  public faBoxOpen = faBoxOpen;
  public faPen = faPen;
  public faSeedling = faSeedling;
  public faSitemap = faSitemap;

  public isLoading: boolean = false;
  public itemId: number;
  public item: InventoryItemDTO;
  private previousUrl: string;

  constructor(
    private inventoryService: InventoryService,
    private errorService: ErrorService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute) {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      if (params.item)
        this.itemId = params.item;
      else
        this.router.navigateByUrl("/harvest-engine/inventory/inventory-items");
    });
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        pairwise(), // check it's second route load
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((e: any[]) => {
        this.previousUrl = e[0].url;
      });

    this.loadItem();
  }

  back() {
    if (this.previousUrl) {
      this.router.navigateByUrl(this.previousUrl);
    } else {
      this.router.navigateByUrl('/harvest-engine/inventory/inventory-items');
    }
  }

  editItem() {
    InventoryItemEditComponent.open(this.dialog, { item: this.item, isPopup: true })
      .afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(saved => {
        if (saved)
          this.loadItem();
      });
  }

  trackByAttribute(_: number, attr: InventoryItemAttributeValueDTO): number | undefined {
    return attr.id;
  }

  private loadItem() {
    if (!this.itemId) return;
    this.isLoading = true;
    this.inventoryService.getInventoryItem(this.itemId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: x => {
        this.item = x;
        this.isLoading = false;
      }, error: err => {
        this.errorService.handleError(err);
        this.isLoading = false;
      }
    });
  }
}
